interface CacheEntry {
  timestamp: number;
  data: any[];
  status: 'loading' | 'ready';
  cancelTimeout?: NodeJS.Timeout;
}

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes in milliseconds
const CACHE = new Map<string, CacheEntry>();

const SnowflakeCache = () => {
  // get
  const get = (key: string) => {
    const entry = CACHE.get(key);
    if (entry) {
      if (entry.status === 'loading') {
        return 'loading'; // Still loading
      } else {
        const now = Date.now();
        if (now - entry.timestamp < CACHE_TTL) {
          return entry.data;
        } else {
          clear(key); // Remove stale entry
        }
      }
    }
    return null;
  }

  const request = (key: string) => {
    const entry: CacheEntry = {
      timestamp: Date.now(),
      data: [],
      status: 'loading',
      cancelTimeout: timeoutCacheEntry(key),
    };
    CACHE.set(key, entry);

  }

  // set
  const cache = (key: string, data: any[]) => {
    const entry: CacheEntry = {
      timestamp: Date.now(),
      data,
      status: 'ready',
      cancelTimeout: timeoutCacheEntry(key),
    };
    CACHE.set(key, entry);

  }

  // clear
  const clear = (key: string) => {
    const entry = CACHE.get(key);
    if (entry && entry.cancelTimeout) {
      clearTimeout(entry.cancelTimeout); // neatly remove any pending timeouts
    }
    CACHE.delete(key);
  }

  // create timeout to clear old cache entries
  const timeoutCacheEntry = (key: string) => {
    const cancel = setTimeout(() => {
      CACHE.delete(key);
    }, CACHE_TTL);
    return cancel;
  }

  return {
    get,
    request,
    cache,
    clear,
  }
}

export { SnowflakeCache };